import React, { useState, useEffect } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { setTransport, resetSelection } from '../../actions/formActions'
import { setPossibleDestinations, setPossibleDepartures } from '../../actions/dataActions'
import { fetchDestinations } from '../../api/fetchDestinations'
import { t } from 'i18next'
import './style.scss'
import { TRANSPORT_CHARTER_TYPE } from '../../consts/data'

const TransportSelect = ({
    selectedTransport,
    transports,
    setTransport,
    onChangeTransport,
    resetSelection,
    setPossibleDestinations,
    setPossibleDepartures
}) => {
    const transportChangeHandler = (transport) => {
        if (transport === selectedTransport) {
            return
        }

        onChangeTransport(true)

        fetchDestinations(transport)
            .then((data) => {
                setTransport(transport)

                resetSelection('z')
                resetSelection('do')

                setPossibleDestinations(data.countryRegion)
                setPossibleDepartures(data.departureFrom)
            })
            .catch((err) => console.log('error', err.message))
            .finally(() => {
                onChangeTransport(false)
            });
    }

    const loadIcon = (item) => {
        switch (item) {
            case 'samolot':
                return (
                    <svg className="transport-list__icon transport-list__icon--plane" fill="#000000" width="800px" height="800px" viewBox="0 0 32 32"
                         version="1.1" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M29.198 2.059c0.326 0 0.555 0.061 0.675 0.107 0.143 0.382 0.336 1.751-1.079 3.167l-7.218 7.218 0.052 0.896c0.11 1.874 0.313 5.232 0.488 8.111 0.154 2.563 0.301 4.983 0.311 5.189 0.005 0.142 0.007 0.175-0.125 0.334-0.295 0.358-0.846 0.966-1.309 1.47-0.72-1.939-2.232-6.033-3.067-8.325l-1.073-2.949-2.22 2.22-4.082 3.924-0.569 0.567-0.018 0.802c-0.014 0.64-0.011 1.79-0.009 2.803 0.002 0.706 0.004 1.348-0.001 1.701-0.009 0.017 0.136 0.036 0.123 0.059-0.087-0.14-0.181-0.29-0.28-0.447-0.823-1.313-1.962-3.128-2.309-3.695l-0.254-0.415-0.417-0.252c-1.516-0.916-3.196-1.973-4.221-2.634 0.035-0.020 0.064 0.088 0.088 0.075h0.067c0.323 0 0.856 0.007 1.453 0.015 0.782 0.011 1.668 0.023 2.346 0.023 0.26 0 0.491-0.002 0.677-0.006l0.803-0.018 0.568-0.567 3.929-4.053 2.212-2.211-2.935-1.080c-2.206-0.812-6.431-2.389-8.408-3.132 0.507-0.467 1.118-1.021 1.474-1.317 0.099-0.082 0.177-0.124 0.231-0.124l0.071 0.002c0.221 0.011 2.959 0.189 5.606 0.363 2.81 0.184 5.982 0.39 7.786 0.505l0.901 0.056 7.22-7.22c1.014-1.013 2.010-1.164 2.514-1.164zM29.198 0.060c-1.181 0-2.632 0.454-3.927 1.75l-6.581 6.581c-3.707-0.235-13.201-0.862-13.437-0.869-0.042-0.002-0.094-0.004-0.152-0.004-0.321 0-0.874 0.061-1.504 0.582-0.74 0.611-2.281 2.062-2.281 2.062-0.372 0.373-0.56 0.835-0.515 1.27 0.027 0.262 0.17 0.741 0.814 0.993 0.392 0.153 6.622 2.485 9.499 3.543l-3.929 4.053c-0.174 0.004-0.39 0.006-0.633 0.006-1.198 0-3.055-0.039-3.8-0.039-0.099 0-0.178 0-0.234 0.002-0.227 0.007-0.696-0.105-1.933 0.929l-0.088 0.082c-0.371 0.371-0.458 0.741-0.466 0.986-0.008 0.252 0.059 0.615 0.424 0.907 0.219 0.177 3.026 1.974 5.329 3.365 0.552 0.901 3.092 4.938 3.225 5.157 0.194 0.327 0.51 0.514 0.889 0.525h0.031c0.368 0 0.746-0.183 1.116-0.542 1.047-1.224 0.902-1.731 0.907-1.945 0.017-0.668-0.011-3.498 0.012-4.62l4.081-3.925c1.043 2.865 3.323 9.031 3.476 9.424 0.254 0.645 0.733 0.786 0.995 0.813 0.043 0.005 0.087 0.007 0.13 0.007 0.395 0 0.803-0.186 1.139-0.52 0 0 1.445-1.534 2.059-2.28s0.591-1.383 0.579-1.683c-0.005-0.208-0.584-9.651-0.799-13.338l6.583-6.583c2.333-2.334 1.962-5.146 1.096-6.011-0.383-0.385-1.157-0.675-2.103-0.675z"></path>
                    </svg>
                )
            case 'autokar':
                return (
                    <svg className="transport-list__icon transport-list__icon--bus" width="800px" height="800px"
                         viewBox="0 0 24 24" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M4 10C4 6.22876 4 4.34315 5.17157 3.17157C6.34315 2 8.22876 2 12 2C15.7712 2 17.6569 2 18.8284 3.17157C20 4.34315 20 6.22876 20 10V12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12V10Z"
                            stroke="#1C274C" strokeWidth="1.5" />
                        <path d="M4 13H20" stroke="#1C274C" strokeWidth="1.5" strokeLinecap="round"
                              strokeLinejoin="round" />
                        <path d="M15.5 16H17" stroke="#1C274C" strokeWidth="1.5" strokeLinecap="round"
                              strokeLinejoin="round" />
                        <path d="M7 16H8.5" stroke="#1C274C" strokeWidth="1.5" strokeLinecap="round"
                              strokeLinejoin="round" />
                        <path d="M6 19.5V21C6 21.5523 6.44772 22 7 22H8.5C9.05228 22 9.5 21.5523 9.5 21V20"
                              stroke="#1C274C"
                              strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M18 19.5V21C18 21.5523 17.5523 22 17 22H15.5C14.9477 22 14.5 21.5523 14.5 21V20"
                              stroke="#1C274C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M20 9H21C21.5523 9 22 9.44772 22 10V11C22 11.3148 21.8518 11.6111 21.6 11.8L20 13"
                              stroke="#1C274C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M4 9H3C2.44772 9 2 9.44772 2 10V11C2 11.3148 2.14819 11.6111 2.4 11.8L4 13"
                              stroke="#1C274C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M19.5 5H4.5" stroke="#1C274C" strokeWidth="1.5" strokeLinecap="round" />
                    </svg>
                )
            case 'wlasny':
                return (
                    <svg className="transport-list__icon transport-list__icon--car" width="800px" height="800px"
                         viewBox="0 0 24 24" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd"
                              d="M5.27097 8.214C6.02074 6.312 6.92262 5 8.96427 5H14.4369C16.4766 5 17.3795 6.312 18.1302 8.214L18.88 10.249C19.4387 10.2559 19.9519 10.5661 20.2284 11.064C20.3911 11.3476 20.4763 11.6709 20.4751 12V14.624C20.4824 15.2367 20.1808 15.8098 19.6776 16.14C19.4382 16.2929 19.162 16.3739 18.88 16.374H4.52022C4.23827 16.3739 3.96199 16.2929 3.72267 16.14C3.21939 15.8098 2.91786 15.2367 2.92512 14.624V12C2.92406 11.6713 3.00927 11.3483 3.17179 11.065C3.44833 10.5671 3.96155 10.2569 4.52022 10.25L5.27097 8.214Z"
                              stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path
                            d="M6.86629 16.375C6.86629 15.9608 6.53051 15.625 6.11629 15.625C5.70208 15.625 5.36629 15.9608 5.36629 16.375H6.86629ZM6.11629 17.688H5.36629C5.36629 17.6958 5.36641 17.7036 5.36666 17.7114L6.11629 17.688ZM4.91899 19L4.89219 19.7495C4.90986 19.7502 4.92754 19.7502 4.9452 19.7496L4.91899 19ZM3.72267 17.687L4.47228 17.711C4.47254 17.703 4.47267 17.695 4.47267 17.687L3.72267 17.687ZM4.47267 16.14C4.47267 15.7258 4.13688 15.39 3.72267 15.39C3.30845 15.39 2.97267 15.7258 2.97267 16.14H4.47267ZM4.52022 9.49902C4.106 9.49902 3.77022 9.83481 3.77022 10.249C3.77022 10.6632 4.106 10.999 4.52022 10.999V9.49902ZM18.88 10.999C19.2942 10.999 19.63 10.6632 19.63 10.249C19.63 9.83481 19.2942 9.49902 18.88 9.49902V10.999ZM18.0349 16.374C18.0349 15.9598 17.6991 15.624 17.2849 15.624C16.8707 15.624 16.5349 15.9598 16.5349 16.374H18.0349ZM17.2849 17.687L18.0335 17.7336C18.0344 17.7181 18.0349 17.7026 18.0349 17.687H17.2849ZM17.8602 18.8173L18.2561 18.1803L18.2561 18.1803L17.8602 18.8173ZM19.1033 18.8173L18.7074 18.1803L18.7074 18.1803L19.1033 18.8173ZM19.6785 17.687H18.9285C18.9285 17.7026 18.929 17.7181 18.93 17.7336L19.6785 17.687ZM20.4285 16.14C20.4285 15.7258 20.0928 15.39 19.6785 15.39C19.2643 15.39 18.9285 15.7258 18.9285 16.14H20.4285ZM5.85012 12.75C5.4359 12.75 5.10012 13.0858 5.10012 13.5C5.10012 13.9142 5.4359 14.25 5.85012 14.25V12.75ZM6.82512 14.25C7.23933 14.25 7.57512 13.9142 7.57512 13.5C7.57512 13.0858 7.23933 12.75 6.82512 12.75V14.25ZM16.5751 12.75C16.1609 12.75 15.8251 13.0858 15.8251 13.5C15.8251 13.9142 16.1609 14.25 16.5751 14.25V12.75ZM17.5501 14.25C17.9643 14.25 18.3001 13.9142 18.3001 13.5C18.3001 13.0858 17.9643 12.75 17.5501 12.75V14.25ZM5.36629 16.375V17.688H6.86629V16.375H5.36629ZM5.36666 17.7114C5.37622 18.0175 5.14582 18.2416 4.89278 18.2505L4.9452 19.7496C6.05927 19.7106 6.90017 18.7608 6.86593 17.6646L5.36666 17.7114ZM4.94579 18.2505C4.69273 18.2415 4.46248 18.0171 4.47228 17.711L2.97305 17.663C2.93793 18.7592 3.77813 19.7097 4.89219 19.7495L4.94579 18.2505ZM4.47267 17.687V16.14H2.97267V17.687H4.47267ZM4.52022 10.999H18.88V9.49902H4.52022V10.999ZM16.5349 16.374V17.687H18.0349V16.374H16.5349ZM16.5364 17.6404C16.4912 18.3667 16.8425 19.0678 17.4642 19.4543L18.2561 18.1803C18.1138 18.0919 18.0217 17.9219 18.0335 17.7336L16.5364 17.6404ZM17.4642 19.4543C18.0887 19.8424 18.8747 19.8424 19.4992 19.4543L18.7074 18.1803C18.5678 18.2671 18.3957 18.2671 18.2561 18.1803L17.4642 19.4543ZM19.4992 19.4543C20.121 19.0678 20.4723 18.3667 20.4271 17.6404L18.93 17.7336C18.9417 17.9219 18.8497 18.0919 18.7074 18.1803L19.4992 19.4543ZM20.4285 17.687V16.14H18.9285V17.687H20.4285ZM5.85012 14.25H6.82512V12.75H5.85012V14.25ZM16.5751 14.25H17.5501V12.75H16.5751V14.25Z"
                            fill="#000000" />
                    </svg>
                )
            default:
                return (
                    <svg className="transport-list__icon transport-list__icon--all" width="800px" height="800px"
                         viewBox="0 0 24 24" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 14L5.23309 16.4248C5.66178 16.7463 6.26772 16.6728 6.60705 16.2581L15 6"
                              stroke="#222222" strokeWidth="1.2" strokeLinecap="round" />
                        <path fillRule="evenodd" clipRule="evenodd"
                              d="M9.95117 15.3293L11.8529 16.8507C12.5375 17.3984 13.5355 17.2931 14.0907 16.6145L22.4644 6.37999C22.6742 6.12352 22.6364 5.7455 22.38 5.53567C22.1235 5.32583 21.7455 5.36363 21.5356 5.6201L13.162 15.8546C13.0231 16.0243 12.7737 16.0506 12.6025 15.9137L10.7111 14.4005L9.95117 15.3293Z"
                              fill="#2A4157" fillOpacity="0.24" />
                    </svg>
                )
        }
    }

    return (
        <div className="dropdown transport-list">
            <button
                className="dropdown-toggle transport-list__button"
                type="button"
                id="transport-list"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="true"
            >
                {t(`form.transport.${selectedTransport}`)}

                {selectedTransport !== TRANSPORT_CHARTER_TYPE && (
                    <span className="caret"></span>
                )}
            </button>
            {selectedTransport !== TRANSPORT_CHARTER_TYPE && (
                <ul className="dropdown-menu transport-list__items" aria-labelledby="transport-list">
                    {transports.map((transport, i) => (
                        <li
                            key={`tr-${i}`}
                            className={`transport-list__item ${transport === selectedTransport ? 'transport-list__item--active' : ''}`}
                            onClick={() => transportChangeHandler(transport)}
                        >
                            {loadIcon(transport)}
                            {t(`form.transport.${transport}`)}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    )
}

const mapStateToProps = (state) => ({
    transports: state.dataReducer.possibleTransports,
    selectedTransport: state.formReducer.transport
})

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setTransport,
            setPossibleDestinations,
            setPossibleDepartures,
            resetSelection
        },
        dispatch
    )

export default connect(mapStateToProps, mapDispatchToProps)(TransportSelect);
